<template>
  <NuxtLayout name="base" :page="page" :copyrights="copyrights">
    <component
      v-for="content in page?.content"
      :is="componentMap[content.__component]"
      :key="content.__component"
      :content="content"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
const { $aosInit } = useNuxtApp()
const componentMap = useContentComponents()
const route = useRoute()
const page = await useFetchPage()

if (!page.value) {
  console.error(`Page ${route.fullPath} is empty`)
}

const copyrights = page.value?.content ? getCopyrights(page.value?.content) : []

provide('copyrights', copyrights)

const { setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale)

onMounted(() => {
  $aosInit()
})

usePageHead(page.value)
</script>
